import { rpcClient } from '../../../rpcClient';
import { createSeatRequestRpc } from '../../../../__generated__/chirp/com/hubspot/personalization/rpc/SeatRequestRpc';
export const sendSeatRequest = async ({
  apiName,
  isLegacySeatsModel,
  requestReason,
  requestedSeatType
}) => {
  const response = await rpcClient.call(createSeatRequestRpc, {
    request: {
      apiName,
      requestReason,
      requestedSeatType,
      sendAdminNotification: !isLegacySeatsModel
    }
  });
  return response.id;
};